import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "../base-service";
import {AppConfig} from "../../config/appconfig";
import {Observable} from "rxjs/Observable";
import { Storage } from '@ionic/storage';

/*
  Generated class for the ReportServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ReportServiceProvider extends BaseService{

  public readonly reporsUrl: string = AppConfig.apiBaseUrl + "reports";

  constructor(
    public http: Http,
    protected storage: Storage
  ) {
    super(http, storage);
  }

  public DailyRun(d1: Date, d2: Date): Observable<any>{
    let url = this.reporsUrl + "/dailyrun" + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  public VehicleWorkFull(d1: Date, d2: Date): Observable<any> {
    let url = this.reporsUrl + "/vehicleworkfull" + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
    //.catch(this.handleError);
  }

  public DailyOrder(d1: Date, d2: Date): Observable<any> {
    let url = this.reporsUrl + "/dailyorder" + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
    //.catch(this.handleError);
  }


  public DailyBlocked(d1: Date, d2: Date): Observable<any> {
    let url = this.reporsUrl + "/dailyblocked" + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
    //.catch(this.handleError);
  }

  public BlockedDetails(vehicleId: number, d1: Date, d2: Date): Observable<any> {
    let url = this.reporsUrl + "/dailyblockeddetails" + "/" + vehicleId.valueOf() + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
  }

  public WorkFullDetails(vehicleId: number, d1: Date, d2: Date): Observable<any> {
    let url = this.reporsUrl + "/vehickeworkfulldetails" + "/" + vehicleId.valueOf() + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
  }

  public StopsMoves(d1: Date, d2: Date): Observable<any>{
    let url = this.reporsUrl + "/stopsmoves" + "/" + d1.valueOf() + "/" + d2.valueOf() + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  public ZonePass(d1: Date, d2: Date): Observable<any>{
    let url = this.reporsUrl + "/zonepass" + "/" + d1.valueOf() + "/" + d2.valueOf();// + "/" + (d1.getTimezoneOffset() * -1).toString();

    return this.http.get(
      url,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }



}



// WEBPACK FOOTER //
// ./src/providers/report-service/report-service.ts